<!-- Created by zhuzi -->
<template>
  <div class="order-detail-page">
    <div class="pay-status">
      <van-icon name="passed" />
      <span>{{ orderInfo.orderStatus }}</span>
    </div>

    <div class="coupon-info-wrapper">
      <div class="coupon-info">
        <img src="@/assets/img/film.png" alt="电影" />
        <div class="info">
          <span class="title">{{ orderInfo.filmName || '' }}</span>
          <span class="subtitle">{{ orderInfo.cinemaName || '' }}</span>
          <span class="tips">{{ seatInfo }}</span>
        </div>
      </div>
    </div>

    <div class="info-card">
      <div class="basic-row">
        <span class="label">订单编号</span>
        <span class="value">{{ orderInfo.orderNumber }}</span>
      </div>
      <div class="basic-row">
        <span class="label">下单时间</span>
        <span class="value">{{ orderInfo.orderTime }}</span>
      </div>
      <div class="basic-row">
        <span class="label">单张票价(均价)</span>
        <span class="value">{{ orderInfo.ticketPrice }}</span>
      </div>
      <div class="basic-row">
        <span class="label">数量</span>
        <span class="value">{{ orderInfo.ticketNum }}</span>
      </div>
      <div class="basic-row">
        <span class="label">付款时间</span>
        <span class="value">{{ orderInfo.paymentTime }}</span>
      </div>
      <div class="basic-row">
        <span class="label">付款方式</span>
        <span class="value">{{ orderInfo.paymentMethod }}</span>
      </div>
    </div>

    <div class="info-card amount-card">
      <div class="amount-row">
        <span class="label">订单金额</span>
        <span class="value">¥ {{ orderInfo.orderAmount }}</span>
      </div>
      <div class="amount-row">
        <span class="label">服务费</span>
        <span class="value">¥ {{ orderInfo.serviceFee }}</span>
      </div>
      <div v-if="orderInfo.refundFlag" class="amount-row">
        <span class="label">退款时间</span>
        <span class="value">{{ orderInfo.refundTime }}</span>
      </div>
      <div v-if="orderInfo.refundFlag" class="amount-row">
        <span class="label">退款金额</span>
        <span class="value">¥ {{ orderInfo.refundAmount }}</span>
      </div>
      <div class="amount-row actual-payment">
        <span class="label"></span>
        <span class="value">实付款：<span class="red">¥ {{ orderInfo.actualPayment }}</span></span>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { getJdMovieOrderDetail } from '@/api/floor'

export default {
  name: 'JdMovieOrderDetail',
  data() {
    return {
      orderId: '',
      orderInfo: {}
    }
  },
  computed: {
    seatInfo() {
      return [this.orderInfo.hallName, this.orderInfo.seatDescribe]
        .filter(Boolean)
        .join(' ')
    }
  },
  mounted() {
    this.orderId = this.$route.query.orderId
    if (this.orderId) {
      this.getDetail()
    }
  },
  methods: {
    getDetail() {
      getJdMovieOrderDetail({ orderId: this.orderId })
        .then(res => {
          if (!res || !res.data) return
          this.orderInfo = res.data
        })
        .catch(err => {
          Toast(err.msg || err.message || '获取订单详情失败')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.order-detail-page {
  width: 100%;
  min-height: 100%;
  padding: 0.1rem;
  box-sizing: border-box;
  text-align: left;

  .pay-status {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 0.135rem;

    .van-icon {
      font-size: 0.17rem;
      color: #0d0d0d;
    }

    span {
      margin-left: 0.07rem;
      color: #0d0d0d;
      font-size: 0.17rem;
      font-weight: 600;
      line-height: 0.17rem;
    }
  }

  .coupon-info-wrapper,
  .info-card {
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    border-radius: 0.06rem;
    box-shadow: 0 0.01rem 0.02rem 0 rgba(192, 192, 192, 0.08);
  }

  .coupon-info-wrapper {
    margin-top: 0.16rem;
    padding: 0.12rem;
  }

  .coupon-info {
    display: flex;

    img {
      flex: 0 0 0.675rem;
      width: 0.675rem;
      height: 0.675rem;
      border-radius: 0.04rem;
    }

    .info {
      display: flex;
      flex: 1;
      min-width: 0;
      height: 0.7rem;
      margin-left: 0.12rem;
      flex-direction: column;
      justify-content: space-around;
    }

    .title,
    .subtitle,
    .tips {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .title {
      color: #0d0d0d;
      font-size: 0.14rem;
      font-weight: 600;
      line-height: 0.2rem;
    }

    .subtitle {
      color: #0d0d0d;
      font-size: 0.14rem;
      font-weight: 500;
      line-height: 0.2rem;
    }

    .tips {
      color: #999;
      font-size: 0.11rem;
      line-height: 0.15rem;
    }
  }

  .info-card {
    margin-top: 0.1rem;
    padding: 0.1rem 0.12rem;
  }

  .basic-row,
  .amount-row {
    display: flex;
    align-items: center;
    font-size: 0.14rem;

    .label {
      color: #666;
      font-weight: 400;
    }

    .value {
      min-width: 0;
      color: #0d0d0d;
      font-weight: 600;
      overflow-wrap: anywhere;
    }
  }

  .basic-row {
    min-height: 0.43rem;

    .label {
      flex: 0 0 30%;
    }

    .value {
      flex: 1;
    }
  }

  .amount-card {
    margin-top: 0.1rem;
  }

  .amount-row {
    min-height: 0.46rem;
    justify-content: space-between;

    .red {
      color: #ff0d37;
    }
  }

}
</style>
